import { InMemoryCache } from '@apollo/client'

import { document } from '@emico/ssr-utils'

import { getGlobalId, rehydratableCaches } from './cacheHydration'

const writeCacheStateToDocument = (cache: InMemoryCache, storeView: string) => {
  const state = cache.extract()
  const initialState = `
        window.${getGlobalId(storeView)}=${JSON.stringify(state).replace(
    /</g,
    '\\u003c',
  )}
    `

  if (!document) {
    return
  }

  // TODO: SSR
  const script = document.createElement('script')
  script.id = `apollo-state-${storeView}`
  script.textContent = initialState
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(script)
  return state
}

export default function dumpCache() {
  if (rehydratableCaches.length === 0) {
    throw new Error('Missing cacheExtract functions!')
  }
  return rehydratableCaches.map(([cache, storeView]) =>
    writeCacheStateToDocument(cache, storeView),
  )
}
